/** @jsxImportSource @emotion/react */
import React, { useEffect, useRef, useState } from 'react';
import { IBlock } from '@datatype/type';
import BoxBlock from '@component/common/block/box-block';
import IconBlock from '@component/common/block/icon-block';
import Gap from '@component/common/gap';
import { useClicker } from '@hook/common/useEvent';

interface IProps {
  source: string;
  timing: {
    begin?: number;
    end?: number;
  };
  design: Pick<IBlock['design'], 'box'>;
}

// TODO: 나중에 커스텀
const AudioBlock: React.FC<IProps> = ({ design, source, timing = {} }) => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [isInitial, setIsInitial] = useState<boolean>(true);
  const [isReplayable, setIsReplayable] = useState<boolean>(false);

  const sleep = (time: number) => new Promise((resolve) => setTimeout(resolve, time));

  // audio 재생이 끝났을때 로직
  const handlePlayCompleted = async () => {
    await sleep(timing?.end || 0);
    setIsPlaying(false);
    setIsInitial(true);
  };

  // audio play 버튼 클릭했을때 로직
  const handlePlayAndPauseClick = useClicker(
    async () => {
      if (!isPlaying) {
        setIsPlaying(true);

        try {
          if (isInitial) {
            setIsReplayable(true);
            setIsInitial(false);
            await sleep(timing?.begin || 0);
          }

          await audioRef.current?.play();
        } catch (e) {
          console.warn('sources block play error:', e);
        }
      } else {
        setIsPlaying(false);
        audioRef.current?.pause();
      }
    },
    1000,
    'throttle',
  );

  // audio replay 버튼 클릭했을때 로직
  const handleReplayClick = useClicker(
    async () => {
      try {
        setIsPlaying(true);

        audioRef.current?.pause();
        if (audioRef.current) audioRef.current.currentTime = 0;

        await sleep(timing?.begin || 0);
        await audioRef.current?.play();
      } catch (e) {
        console.warn('sources block play error:', e);
      }
    },
    1000,
    'throttle',
  );

  return (
    <BoxBlock design={{ box: design.box }}>
      {/*<IconBlock*/}
      {/*  icon={isPlaying ? 'pause' : 'play'}*/}
      {/*  design={{*/}
      {/*    icon: { size: 'medium', kind: 'filled' },*/}
      {/*    box: { event: { cursor: 'pointer' } },*/}
      {/*  }}*/}
      {/*  click={{*/}
      {/*    handler: handlePlayAndPauseClick,*/}
      {/*  }}*/}
      {/*/>*/}
      {/*{isReplayable && (*/}
      {/*  <IconBlock*/}
      {/*    icon={'replay'}*/}
      {/*    design={{*/}
      {/*      icon: { size: 'medium', kind: 'filled' },*/}
      {/*      box: { event: { cursor: 'pointer' } },*/}
      {/*    }}*/}
      {/*    click={{*/}
      {/*      handler: handleReplayClick,*/}
      {/*    }}*/}
      {/*  />*/}
      {/*)}*/}
      <audio
        ref={(element) => {
          if (element) audioRef.current = element;
        }}
        src={source}
        onEnded={handlePlayCompleted}
        controls={true}
      />
    </BoxBlock>
  );
};

export default AudioBlock;
